// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__8Ed8e","header":"PatientBlock_header__Eh_fw","label":"PatientBlock_label__EHJCv","option":"PatientBlock_option__1KGQB"};